import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex align-items-center" }

import { ref } from 'vue';
import { EMIT } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpireSwitch',
  setup(__props, { emit: __emit }) {

const emit = __emit;
const showExpired = ref(false);
const handleToggle = () => (showExpired.value ? emit(EMIT.ENABLE) : emit(EMIT.DISABLE));

return (_ctx: any,_cache: any) => {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InputSwitch, {
      modelValue: showExpired.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showExpired).value = $event)),
      onChange: handleToggle
    }, null, 8, ["modelValue"]),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-gray-600 label pl-2 align-items-center flex font-semibold" }, "Show Expired", -1))
  ]))
}
}

})